import ManagerDashboard from './ManagerDashboard';

export default ManagerDashboard;
